import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import { SystemSmtpForm, mountForm, unmountForm } from '@kineticdata/react';
import {
  generateFormButtons,
  FormError,
  SecretField,
  SecretFieldGroup,
  ChangeSecretField,
} from '@kineticdata/ui';
import { regRoute, regSaga } from '../../store';

const formKey = 'system-setup-smtp';

regRoute('SYSTEM_SMTP_PAGE', '/system/setup/infra/smtp');

regSaga(
  takeEvery('ENTER_SYSTEM_SMTP_PAGE', function* () {
    yield call(mountForm, formKey);
  }),
);
regSaga(
  takeEvery('LEAVE_SYSTEM_SMTP_PAGE', function* () {
    yield call(unmountForm, formKey);
  }),
);

const FormLayout = ({ fields, error, buttons }) => (
  <form>
    <div className="heading heading-sm">
      <h2 className="h3">SMTP Setup</h2>
    </div>
    <div className="row">
      <div className="col-9">{fields.get('host')}</div>
      <div className="col-3">{fields.get('port')}</div>
      <div className="col-6">{fields.get('username')}</div>
      <div className="col-6">
        <SecretFieldGroup
          secretField={fields.get('password')}
          changeSecretField={fields.get('passwordChange')}
        />
      </div>
      <div className="col-6">{fields.get('tlsEnabled')}</div>
    </div>

    <fieldset>
      <legend className="h4">Mailer Settings</legend>
      <div className="row">
        <div className="col-4">{fields.get('fromName')}</div>
        <div className="col-8">{fields.get('fromAddress')}</div>
      </div>
    </fieldset>

    <fieldset>
      <legend className="h4">Validation Email Recipient</legend>
      <div className="row">
        <div className="col-12">{fields.get('toAddress')}</div>
      </div>
    </fieldset>

    {error}
    <div className="form-buttons">{buttons}</div>
  </form>
);

export const SystemSetupSmtp = () => (
  <div className="content-container">
    <SystemSmtpForm
      formKey={formKey}
      alterFields={{
        password: {
          component: SecretField,
        },
        passwordChange: {
          component: ChangeSecretField,
        },
      }}
      components={{
        FormError,
        FormButtons: generateFormButtons({
          submitLabel: 'Update SMTP Settings',
          cancelPath: '/system/setup/config',
        }),
        FormLayout,
      }}
    >
      {({ form }) => form}
    </SystemSmtpForm>
  </div>
);
